module.exports = __webpack_public_path__ + "media/images/avaka_mini-c4eaaeba7aca0496f010c28c28748057.png";